import {typography} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useMemo, useState} from "react";
import {stylesheet} from "typestyle";
import {boxShadow} from "./themes";
import {Shop, Shops, ShopType} from "./types";
import {useLocalization} from "../i18n";

interface ShopSelectionViewProps {
    shops: Shops;
    onSelect: (shop: Shop) => void;
}

export function ShopList({shops, onSelect}: ShopSelectionViewProps) {
    return (
        <div className={styles.shopList}>
            {Object.entries(shops).map(([key, shop]) => (
                <ShopListItem key={key} shop={shop} onClick={onSelect}/>
            ))}
        </div>
    );
}

interface ShopListItem {
    shop: Shop;
    onClick: (shop: Shop) => void;
}

function ShopListItem({shop, onClick}: ShopListItem) {
    const handleClick = useCallback(() => onClick(shop), [shop, onClick]);
    const {name, offer, shopType} = shop;

    const [logoUrl, setLogoUrl] = useState(() => shop.logoUrl);

    const handleLogoError = useCallback(() => setLogoUrl(undefined), []);

    const DESCRIPTION_MAX_LENGTH = 70;
    const description = useMemo( () => {
        if(offer.shortDescription && offer.shortDescription.length > DESCRIPTION_MAX_LENGTH){
            return offer.shortDescription.slice(0,DESCRIPTION_MAX_LENGTH).concat("...");
        }else{
            return offer.shortDescription;
        }
    }, [offer.shortDescription]);

    return (
        <div className={styles.shopListItem} onClick={handleClick}>
            <div className={styles.logoContainer}>
                {logoUrl && (
                    <img alt="Logo" src={shop.logoUrl} className={styles.logo} draggable={false} onError={handleLogoError} />
                )}
                {!logoUrl && <div className={styles.name}>{name}</div>}
            </div>
            <div className={styles.shopItemText}>
                <div className={typography.title}>
                    {name}
                </div>
                <div>
                    {description || getDescription(shopType)}
                </div>
            </div>
        </div>
    );
}

function getDescription(shopType: ShopType) {
    //const strings = useStrings(resources);
    const {t} = useLocalization();
    switch (shopType) {
        case ShopType.DryCleaning:
            return t("DryCleaning");
        case ShopType.Services:
            return t("Services");
        case ShopType.Goods:
            return t("Goods");
    }
}

const styles = stylesheet({
    shopList: {
        display: "flex",
        flexFlow: "row wrap",
        padding: "0.75em",
        height: "100%",
        overflowY: "scroll",
    },
    shopListItem: {
        flex: 1,
        margin: "0.75em",
        minWidth: "14em",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "1em",
        boxShadow,
        maxWidth: "calc(50% - 0.75em)"
    },
    logoContainer: {
        height: "12em",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2em"
    },
    logo: {
        width: "auto",
        height: "100%",
        maxHeight: "8em",
        maxWidth: "100%",
    },
    name: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "1.25em",
    },
    shopItemText: {
        padding: "0.75em 1.25em",
        textAlign: "center",
        // backgroundColor: "#f0f0f0",
        borderRadius: "0 0 1em 1em"
    }
});
